require('./bootstrap');

// Import modules...
import { createApp, h } from 'vue'
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import mitt from 'mitt'
import Maska from 'maska'
import money from 'v-money'

const emitter = mitt()

const siteApp = createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(document.getElementById('app').dataset.page),
            resolveComponent: (name) => require(`./Pages/${name}`).default,
        }),
})

Sentry.init({
    siteApp,
    dsn: "https://e5f0add0142f4e4aa6ecafd9d65700c3@o1125088.ingest.sentry.io/6164222",
    integrations: [
        new Integrations.BrowserTracing({
            tracingOrigins: ["onboarding.test", "onboarding.mammothresearch.com", /^\//],
        }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
    tracingOptions: {
        trackComponents: true,
    },
    logErrors: true,
    attachProps: true,
	attachStacktrace: true,
})

siteApp.config.globalProperties.emitter = emitter;

siteApp.directive('click-away', require('./Directives/click-away').default)
siteApp.directive('currency', require('./Directives/currency-format').default)
siteApp.directive('maska', Maska.maska)

siteApp.mixin({
    methods: {
        route,
        asset(path){
            var base_path = window._asset || '';

            return base_path + path;
        },
        normalizeInputAttributes(){
            return _.omitBy(this.$attrs, (attr, index) => {
                return _.includes(['desc', 'label', 'type', 'id'], index)
            })
        },
    }
})

// # MASKA
siteApp.use(Maska)

// # MONEY
siteApp.use(money, { precision: 4 })

// # INERTIA
siteApp.use(InertiaPlugin)

// # STATE MANAGEMENT
siteApp.use(require('./store').default)

siteApp.mount(document.getElementById('app'))

InertiaProgress.init({ color: '#00F4C8' })
